// extracted by mini-css-extract-plugin
export default {"social-icon":"SocialButton_social-icon__xt04f"};